import { Controller } from '@hotwired/stimulus';
import { fireChangeEvent } from '../search/accordion_change';
import { applyServerValue } from '../../utils/select/native_select';

export default class NumberRangeBaseController extends Controller {
  static targets = ['from', 'to'];
  static values = { unit: String, serverFrom: String, serverTo: String };

  connect() {
    fireChangeEvent(this.element, this._getDisplayText());
  }

  onFormReset(event) {
    if (!event.target.contains(this.element)) {
      return;
    }

    this._applyServerValues();
    fireChangeEvent(this.element, this._getDisplayText());
  }

  onChange(event) {
    const swapped = this._swapValuesIfToLowerThanFrom();
    if (swapped) {
      const otherTarget = event.target === this.fromTarget ? this.toTarget : this.fromTarget;
      otherTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }
    fireChangeEvent(this.element, this._getDisplayText());
  }

  _applyServerValues() {
    applyServerValue(this.fromTarget, this.serverFromValue);
    applyServerValue(this.toTarget, this.serverToValue);
  }

  _swapValuesIfToLowerThanFrom() {
    const from = { value: this.fromTarget.value, rawValue: this.fromTarget.dataset.rawValue };
    const to = { value: this.toTarget.value, rawValue: this.toTarget.dataset.rawValue };

    const onlyOneHasRawValue = !!from.rawValue !== !!to.rawValue;
    if (onlyOneHasRawValue) {
      return false;
    }

    const bothHaveRawValue = from.rawValue && to.rawValue;
    const fromCompareValue = bothHaveRawValue ? from.rawValue : from.value;
    const toCompareValue = bothHaveRawValue ? to.rawValue : to.value;

    if (!fromCompareValue || !toCompareValue) {
      return false;
    }

    if (Number.parseFloat(fromCompareValue) <= Number.parseFloat(toCompareValue)) {
      return false;
    }

    this.toTarget.value = from.value;
    this.fromTarget.value = to.value;

    if (bothHaveRawValue) {
      this.toTarget.dataset.rawValue = from.rawValue;
      this.fromTarget.dataset.rawValue = to.rawValue;
    }

    return true;
  }

  _getUnit() {
    return this.unitValue ?? '';
  }

  _getDisplayText() {
    const values = [];
    if (this.fromTarget.value) {
      values.push(`min: ${this.fromTarget.value} ${this._getUnit()}`);
    }
    if (this.toTarget.value) {
      values.push(`max: ${this.toTarget.value} ${this._getUnit()}`);
    }
    if (values.length === 0) {
      return null;
    }
    return values.join(', ');
  }
}
